"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var Dropdown_1 = __importDefault(require("../../inputs/Dropdown"));
var utils_1 = require("../SpecializaceField/utils");
var SelectSpecializace_1 = __importDefault(require("./SelectSpecializace"));
var FieldWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 1em;\n"], ["\n  margin-top: 1em;\n"])));
var mapToOptions = ramda_1.pipe(ramda_1.defaultTo([]), ramda_1.map(function (item) { return ({ value: item.idSpecializace, label: item.nazev }); }));
var findById = function (id) { return ramda_1.find(function (item) { return item.idSpecializace === id; }); };
var VyhledavaniSpecializaceField = function (_a) {
    var _b, _c, _d, _e;
    var name = _a.name, defaultSelect = _a.defaultSelect, enableReset = _a.enableReset;
    var _f = formik_1.useField(name), field = _f[0], meta = _f[1], helpers = _f[2];
    var _g = hooks_1.useCiselnik('specializace'), data = _g.data, loading = _g.loading, error = _g.error;
    var value = field.value || {};
    var _h = react_1.useState(), defaultOption = _h[0], setDefaultOption = _h[1];
    react_1.useEffect(function () {
        if (defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) {
            if (defaultSelect.values.specializace) {
                var spec = utils_1.getSpecializaceById(defaultSelect.values.specializace, data || []);
                if (spec)
                    setDefaultOption({ selected: spec.idSpecializace, option: { value: spec === null || spec === void 0 ? void 0 : spec.idSpecializace, label: spec === null || spec === void 0 ? void 0 : spec.nazev } });
            }
            helpers.setValue(defaultSelect.values || {});
        }
    }, [data, (_b = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _b === void 0 ? void 0 : _b.obor, (_c = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _c === void 0 ? void 0 : _c.odvetvi, (_d = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _d === void 0 ? void 0 : _d.specializace]);
    if (loading) {
        return (react_1.default.createElement(Field_1.default, null,
            react_1.default.createElement("div", null, "na\u010D\u00EDt\u00E1n\u00ED")));
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var handleSetObor = function (o) {
        helpers.setValue({ obor: o });
        setDefaultOption(undefined);
    };
    var handleSetOdvetvi = function (o) {
        var odvetvi = utils_1.getSpecializaceById(o || 0, data || []);
        helpers.setValue({ obor: (odvetvi === null || odvetvi === void 0 ? void 0 : odvetvi.idNadrazene) || value.obor || undefined, odvetvi: o });
        setDefaultOption(undefined);
    };
    var handleSetSpecializace = function (o) {
        var allSpecializace = data || [];
        var specObj = utils_1.getSpecializaceById(o, allSpecializace);
        if (specObj === null || specObj === void 0 ? void 0 : specObj.idNadrazene) {
            var odvetviObj = utils_1.getSpecializaceById(specObj.idNadrazene, allSpecializace);
            if (odvetviObj === null || odvetviObj === void 0 ? void 0 : odvetviObj.idNadrazene) {
                var oborObj = utils_1.getSpecializaceById(odvetviObj.idNadrazene, allSpecializace);
                if (oborObj) {
                    helpers.setValue({ obor: oborObj.idSpecializace, odvetvi: odvetviObj.idSpecializace, specializace: o });
                    return;
                }
            }
        }
        helpers.setValue(__assign(__assign({}, field.value), { specializace: o }));
    };
    var loadOdvetviOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var oborObj;
        return __generator(this, function (_a) {
            oborObj = findById(value.obor)(data || []);
            if (oborObj) {
                return [2 /*return*/, mapToOptions(oborObj.podrizene.sort(function (a, b) { return a.nazev.localeCompare(b.nazev); }))];
            }
            return [2 /*return*/, mapToOptions(data === null || data === void 0 ? void 0 : data.reduce(function (acc, curr) { return __spreadArrays(acc, (curr.podrizene || [])); }, []).sort(function (a, b) { return a.nazev.localeCompare(b.nazev); }))];
        });
    }); };
    return (react_1.default.createElement(FieldWrapper, null,
        react_1.default.createElement(Field_1.default, null,
            react_1.default.createElement(Label_1.default, { htmlFor: "Obor" }, "Obor"),
            react_1.default.createElement(Dropdown_1.default, { value: value.obor, onChange: handleSetObor, placeholder: "Vyberte ze seznamu", loadOptions: function () { return Promise.resolve(mapToOptions(data)); }, enableReset: enableReset, inputId: "Obor", hasError: !!meta.error })),
        react_1.default.createElement(Field_1.default, null,
            react_1.default.createElement(Label_1.default, { htmlFor: "Odvetvi" }, "Odv\u011Btv\u00ED"),
            react_1.default.createElement(Dropdown_1.default, { onChange: handleSetOdvetvi, value: value.odvetvi, name: "Odvetvi", placeholder: "Vyberte ze seznamu", loadOptions: loadOdvetviOptions, enableReset: enableReset, inputId: "Odvetvi" })),
        react_1.default.createElement(SelectSpecializace_1.default, { label: "Specializace", name: "specializace", onChange: handleSetSpecializace, value: value.specializace, parentId: (_e = value.odvetvi) !== null && _e !== void 0 ? _e : value.obor, defaultOption: defaultOption, enableReset: enableReset })));
};
VyhledavaniSpecializaceField.defaultProps = {
    enableReset: false,
    defaultSelect: undefined,
};
exports.default = VyhledavaniSpecializaceField;
var templateObject_1;
